import { render } from "./AddSchoolYearDialog.vue?vue&type=template&id=08e236c9"
import script from "./AddSchoolYearDialog.vue?vue&type=script&lang=js"
export * from "./AddSchoolYearDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__